var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faq" },
    [
      _vm.$route.query.isApp != 1
        ? _c("van-nav-bar", {
            staticClass: "apiHeader",
            attrs: { title: _vm.$t("300270"), "left-arrow": "" },
            on: {
              "click-left": function($event) {
                return _vm.$router.go(-1)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "apiBody" }, [
        _c(
          "div",
          { staticClass: "commont_body" },
          [
            _c(
              "van-collapse",
              {
                attrs: { border: false },
                model: {
                  value: _vm.activeNames,
                  callback: function($$v) {
                    _vm.activeNames = $$v
                  },
                  expression: "activeNames"
                }
              },
              [
                _c(
                  "van-collapse-item",
                  { attrs: { title: "1. " + _vm.$t("9100117"), name: "1" } },
                  [
                    _c("span", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("9100122")) +
                          "\n                    "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-collapse-item",
                  { attrs: { title: "2. " + _vm.$t("9100118"), name: "2" } },
                  [
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.$t("9100123")) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-collapse-item",
                  { attrs: { title: "3. " + _vm.$t("9100119"), name: "3" } },
                  [
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.$t("9100124")) }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-collapse-item",
                  { attrs: { title: "4. " + _vm.$t("9100120"), name: "4" } },
                  [
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.$t("9100125")) }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b278a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b278a6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/apiKey/FAQ.vue
// module id = LZ5a
// module chunks = 0